import React from 'react';

interface FormRowProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function FormRow({ children, className = '', ...rest }: FormRowProps) {
    const classes = ['form-row', className].filter(Boolean).join(' ');
    return (
        <div className={classes} {...rest}>
            {children}
        </div>
    );
}
